import API_ENDPOINTS from "../Config/api";
import { clearSessionAndRedirect } from './logoutRedirect';

// Mutex to prevent multiple simultaneous refresh calls
// (critical with BLACKLIST_AFTER_ROTATION=True — only the first refresh succeeds)
let refreshPromise = null;

export async function fetchWithAuth(url, options = {}, retry = true) {
  const accessToken = sessionStorage.getItem('access_token');

  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
    Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
  };

  const config = {
    ...options,
    headers,
    credentials: 'include',
  };

  try {
    const response = await fetch(url, config);

    if ((response.status === 401 || response.status === 403) && retry) {
      const refreshed = await refreshAccessToken();
      if (refreshed) {
        return fetchWithAuth(url, options, false); // Retry solo una volta
      } else {
        // Non forzare logout, restituisci errore gestibile
        const error = new Error('Unauthorized');
        error.status = response.status;
        throw error;
      }
    }

    return response;
  } catch (err) {
    // Non forzare logout, restituisci errore gestibile
    throw err;
  }
}

async function refreshAccessToken() {
  // If a refresh is already in progress, wait for it instead of making a second call
  if (refreshPromise) {
    return refreshPromise;
  }

  const refresh = sessionStorage.getItem('refresh_token');

  if (!refresh) {
    forceLogout();
    return false;
  }

  refreshPromise = (async () => {
    try {
      const res = await fetch(API_ENDPOINTS.refreshToken, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ refresh }),
      });

      if (!res.ok) {
        forceLogout();
        return false;
      }

      const data = await res.json();
      if (data.access) {
        sessionStorage.setItem('access_token', data.access);
        if (data.refresh) {
          sessionStorage.setItem('refresh_token', data.refresh);
        }
        return true;
      }

      forceLogout();
      return false;
    } catch {
      forceLogout();
      return false;
    } finally {
      refreshPromise = null;
    }
  })();

  return refreshPromise;
}

function forceLogout() {
  clearSessionAndRedirect();
}
